import AppConfig from '~/config/appConfig.js'
import { useResource } from '@/composables/resources/useResource.js'
import { useUserStore } from '@/stores/userStore.js'

export function useApiResource(baseEndpoint = null) {
  const userStore = useUserStore()

  let host = AppConfig.runtime.isProduction() ? "https://beta.sasa.solutions" : "http://localhost:3000"
  let baseUrl = `${host}/pwa`
  if (baseEndpoint != null) baseUrl = `${baseUrl}/${baseEndpoint}`

  function _headers() {
    return {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': userStore.authenticationKey
    }
  }

  function _options() {
    return {
      mode: 'cors',
      cache: 'no-cache',
      referrerPolicy: 'no-referrer'
    }
  }

  function _resourceOptions() {
    return {
      responseType: 'json'
    }
  }

  let resource = useResource(baseUrl, {
    defaultHeaders: _headers,
    defaultOptions: _options,
    defaultResourceOptions: _resourceOptions
  })
  
  function updateMethod() {
    return resource.put
  }

  function performDestroy(uuid) {
    return resource.del(`/${uuid}`)
  }

  return {
    ...resource,
    updateMethod,
    performDestroy,
    host,
    baseUrl,
  }
}
